module.exports = __webpack_public_path__ + "img/mastercard.e1310621.svg";